// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"4afc5730","244":"e6b44b54","764":"d1466598","807":"a2efe3ec"}[chunkId] + ".css";
};